@if (menuItems) {
    <menu class="m-0 menu d-flex flex-row flex-wrap">
        @for (item of menuItems; track item) {
            <div class="menu__item me-3">
                <a
                    class="a--border-off"
                    target="_blank"
                    rel="noopener"
                    [class.a--white]="selected !== item.url"
                    [class.a--selected]="selected === item.url"
                    [href]="item.url | currentProtocol"
                    [attr.title]="item.mdName"
                    >{{ item.mdName }}</a
                >
            </div>
        }
    </menu>
}
